var _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 46,
    viewBox: "0 0 50 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_10897_16478)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 25,
    cy: 22.8756,
    rx: 11.25,
    ry: 9.91071,
    fill: "url(#paint0_linear_10897_16478)",
    style: {
      mixBlendMode: "multiply"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 21,
    r: 15,
    fill: "#C1C5D6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3169 14.8778C33.2277 15.7887 33.2277 17.2655 32.3169 18.1764L22.6815 27.8117C22.561 27.9323 22.3974 28 22.2269 28H18.6429C18.2878 28 18 27.7122 18 27.3571V23.7731C18 23.6026 18.0677 23.439 18.1883 23.3185L27.8236 13.6831C28.7345 12.7723 30.2113 12.7723 31.1222 13.6831L32.3169 14.8778ZM31.4077 17.2672C31.8165 16.8585 31.8165 16.1957 31.4077 15.787L30.213 14.5923C29.8043 14.1835 29.1415 14.1835 28.7328 14.5923L26.9749 16.3502L29.6498 19.0251L31.4077 17.2672ZM28.7407 19.9343L26.0657 17.2593L19.2857 24.0393V26.7143H21.9607L28.7407 19.9343Z",
    fill: "#242833"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_10897_16478",
    x: 0.892857,
    y: 0.1077,
    width: 48.2143,
    height: 45.5366,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.42857,
    result: "effect1_foregroundBlur_10897_16478"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10897_16478",
    x1: 25,
    y1: 1.79922,
    x2: 2.51049,
    y2: 24.4587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E4AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504968,
    stopColor: "#10C5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9240DC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.2934a853761cd94c44eb4fb5435bb2f9.svg";
export { ForwardRef as ReactComponent };